import IconContainer, { IconContainerProps } from "./IconContainer";

export default function IconSummary(props: IconContainerProps) {
    return <IconContainer {...props}>
        docs
    </IconContainer>
}